export function normalizeHeader(header: string): string {
  return header.toLowerCase().trim();
}

export function sanitizeCode(code: string): string {
  return code.trim().toUpperCase();
}

export function validateSeverity(severity: string): 'fatal' | 'retryable' | 'user' | 'debug' {
  const validSeverities = ['fatal', 'retryable', 'user', 'debug'] as const;
  const normalized = severity.toLowerCase().trim();
  
  if (validSeverities.includes(normalized as any)) {
    return normalized as 'fatal' | 'retryable' | 'user' | 'debug';
  }
  
  return 'debug';
}